import { initChat, initTabbedChats } from "crosstalk-comments-livechat-sdk";
export function autoInitTabbedChats(config) {
    initTabbedChats(config);
}
export function autoInitChats() {
    const chatDivs = document.querySelectorAll('div[data-crosstalk-chat]');
    const chatEmbeds = [];
    chatDivs.forEach(chatDiv => {
        const config = {
            wp: chatDiv.dataset.wp,
            url: chatDiv.dataset.url || "",
            pageID: chatDiv.dataset.pageId || "",
            theme: chatDiv.dataset.theme || "light",
            height: chatDiv.dataset.height || "500px",
            locale: chatDiv.dataset.lang || "en"
        };
        const instance = initChat(chatDiv, config);
        if (instance)
            chatEmbeds.push(instance);
    });
    return chatEmbeds;
}
